// audio.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  private audioContext: AudioContext;
  private audioBuffer!: AudioBuffer;

  constructor() {
    this.audioContext = new AudioContext();
  }
  private initializeAudioContext(): void {
    this.audioContext = new AudioContext();
  }
  loadAudio(): Promise<void> {
    const audioPath = 'assets/telephoneRing.mp3'; // Updated MP3 path

    return fetch(audioPath)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch audio: ${response.statusText}`);
        }
        return response.arrayBuffer();
      })
      .then((audioData) => this.audioContext.decodeAudioData(audioData))
      .then((buffer) => {
        this.audioBuffer = buffer;

      })
      .catch((error) => {
        console.error('Error loading audio:', error);
        throw error; // Propagate the error
      });
  }

  playAudio(): void {
    const source = this.audioContext.createBufferSource();
    source.buffer = this.audioBuffer;
    source.connect(this.audioContext.destination);
    source.loop = true;
    source.start(0);
  }

  stopAudio(): void {
    this.audioContext.close();
    this.initializeAudioContext();
  }

  async checkMicrophone(): Promise<boolean> {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasMicrophone = devices.some((device) => device.kind === 'audioinput');
      return hasMicrophone;
    } catch (error) {
      console.error('Error checking microphone availability:', error);
      return false;
    }
  }

  async checkMicrophonePermission(): Promise<PermissionState | 'not-supported'> {
    if (navigator.permissions && navigator.permissions.query) {
      try {
        // 'microphone' is not standard in all TS lib versions, so casting to any
        const result = await navigator.permissions.query({ name: 'microphone' as any });
        return result.state; // 'granted', 'denied', 'prompt'
      } catch (error) {
        console.error('Error checking microphone permission:', error);
        return 'not-supported';
      }
    }
    return 'not-supported';
  }

  async requestMicrophonePermission(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Permission granted, close the stream immediately as we just wanted to ask permission
      stream.getTracks().forEach(track => track.stop());
      return true;
    } catch (error: any) {
      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        console.warn('Microphone permission denied by user.');
      } else {
        console.error('Error requesting microphone permission:', error);
      }
      return false; // Permission denied or error
    }
  }
}
